import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { fadeIn } from 'src/app/theme/utils/app-animation';
@Component({
	selector: 'app-busy-indicator',
	templateUrl: './busy-indicator.component.html',
	styleUrls: ['./busy-indicator.component.scss'],
	animations: [fadeIn],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BusyIndicatorComponent {
	@Input() isBusy: boolean;
	@Input() size: string; // small big xs
	@Input() showBackDrop = true;
	@Input() message: string;
}
